__turbopack_context__.v({
  "cartEmpty": "fIppJa_cartEmpty",
  "control": "fIppJa_control",
  "header": "fIppJa_header",
  "item": "fIppJa_item",
  "links": "fIppJa_links",
  "links2": "fIppJa_links2",
  "nav": "fIppJa_nav",
  "nav2": "fIppJa_nav2",
  "need": "fIppJa_need",
  "notice": "fIppJa_notice",
  "noticeContainer": "fIppJa_noticeContainer",
  "sub": "fIppJa_sub",
  "tav": "fIppJa_tav",
});
